// @ts-nocheck
import React, { createContext, useContext, useState, useEffect } from 'react';

const COLORS = {
    green: { primary: '#1a5f2a', primaryDark: '#0f3d1a', primaryLight: '#2d8a45', accent: '#c9a227' },
    blue: { primary: '#1a4a7a', primaryDark: '#0d2d4d', primaryLight: '#2b6cb0', accent: '#3182ce' },
    purple: { primary: '#5b2c6f', primaryDark: '#3b1a4a', primaryLight: '#8e44ad', accent: '#a569bd' },
    teal: { primary: '#0e6655', primaryDark: '#0a4740', primaryLight: '#148f77', accent: '#1abc9c' },
    orange: { primary: '#b85c00', primaryDark: '#7a3d00', primaryLight: '#e67e22', accent: '#f39c12' },
};

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
    const [mode, setMode] = useState(() => localStorage.getItem('rems_theme') || 'light');
    const [color, setColor] = useState(() => localStorage.getItem('rems_color') || 'green');

    useEffect(() => {
        localStorage.setItem('rems_theme', mode);
        localStorage.setItem('rems_color', color);
        const root = document.documentElement;
        root.setAttribute('data-theme', mode);
        root.setAttribute('data-color', color);
        const c = COLORS[color] || COLORS.green;
        root.style.setProperty('--primary', c.primary);
        root.style.setProperty('--primary-dark', c.primaryDark);
        root.style.setProperty('--primary-light', c.primaryLight);
        root.style.setProperty('--accent', c.accent);
    }, [mode, color]);

    const toggleMode = () => setMode((m) => (m === 'light' ? 'dark' : 'light'));

    return (
        <ThemeContext.Provider value={{ mode, setMode, color, setColor, toggleMode, colors: Object.keys(COLORS) }}>
            {children}
        </ThemeContext.Provider>
    );
}

export const useTheme = () => useContext(ThemeContext);
